module.exports = __webpack_public_path__ + "static/media/healthy-can-be-simple.dcd74a90.png";